/** @param {$} window.jQuery */
export default window.jQuery;
